const KEY = 'attribution.v1'
const AFF_KEY = 'affiliate.v1'
const AFF_TTL_MS = 30 * 24 * 3600 * 1000

function sanitizeCode(raw) {
  return String(raw || '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9_-]/g, '')
    .slice(0, 32) || null
}

function captureAffiliate() {
  if (typeof window === 'undefined') return
  try {
    const params = new URLSearchParams(window.location.search)
    const code = sanitizeCode(params.get('aff'))
    if (!code) return
    const now = Date.now()
    window.localStorage.setItem(
      AFF_KEY,
      JSON.stringify({ code, capturedAt: now, expiresAt: now + AFF_TTL_MS }),
    )
  } catch {}
}

function readAffiliate() {
  if (typeof window === 'undefined') return null
  try {
    const raw = window.localStorage.getItem(AFF_KEY)
    if (!raw) return null
    const data = JSON.parse(raw)
    if (!data?.code) return null
    if (data.expiresAt && Date.now() > data.expiresAt) {
      window.localStorage.removeItem(AFF_KEY)
      return null
    }
    return data.code
  } catch {
    return null
  }
}

export function captureAttribution() {
  if (typeof window === 'undefined') return
  captureAffiliate()
  try {
    const existing = sessionStorage.getItem(KEY)
    if (existing) return
    const params = new URLSearchParams(window.location.search)
    const data = {
      utmSource: params.get('utm_source') || null,
      utmMedium: params.get('utm_medium') || null,
      utmCampaign: params.get('utm_campaign') || null,
      utmTerm: params.get('utm_term') || null,
      utmContent: params.get('utm_content') || null,
      referrer: (document.referrer || '').slice(0, 200) || null,
      landingPath: window.location.pathname + window.location.search,
    }
    if (data.landingPath.length > 500) data.landingPath = data.landingPath.slice(0, 500)
    sessionStorage.setItem(KEY, JSON.stringify(data))
  } catch {}
}

export function getAttribution() {
  if (typeof window === 'undefined') return {}
  let base = {}
  try {
    const raw = sessionStorage.getItem(KEY)
    if (raw) base = JSON.parse(raw)
  } catch {}
  const code = readAffiliate()
  if (code) base.affiliateCode = code
  return base
}
